module.exports = __webpack_public_path__ + "img/sanitarni-bojler.e95be36f.png";